import * as React from 'react';
import {Label} from './LinkUIComponents';
import {getSortedNamedElements} from '@packages/systems/core/utils/DomIdUtils';
import type {State, ChangeTypes} from './LinkTypes';
import {selectComponents} from '@packages/utilities/platform-selectors';
import {SectionSelectorPopover} from '@packages/systems/designer/section-select';
import {useDesignerSelector} from '@packages/systems/designer/flux';

export const useDomId = (state: State, dispatch: (arg1?: any) => void) => {
  const [domId, setDomId] = React.useState(state.domId);

  const onChange = React.useCallback(
    (
      newDomId: string | null | undefined,
      {
        changeType,
      }: {
        changeType: ChangeTypes;
      }
    ) => {
      if (changeType === 'changeEnd') {
        // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'SetStateAction<string | undefined>'.
        setDomId(newDomId);
        dispatch({
          payload: {...state, domId: newDomId},
          meta: {
            analytics: {
              type: 'element-settings-updated',
              value: 'link section',
            },
          },
        });
      }
    },
    [dispatch, state]
  );

  React.useEffect(() => {
    // When switching modes, we reset to undefined so we can show the placeholder.
    if (!state.domId) {
      setDomId(undefined);
    } else if (state.domId && domId !== state.domId) {
      setDomId(state.domId);
    }
  }, [onChange, state.domId, domId]);

  return {onChange, domId};
};

export const LinkSectionMode = ({
  state,
  dispatch,
  isOverride,
}: {
  state: State;
  dispatch: (arg1?: any) => void;
  isOverride: boolean;
}) => {
  const {domId, onChange} = useDomId(state, dispatch);
  const components = useDesignerSelector(selectComponents);
  const namedElements = getSortedNamedElements(components);

  // Memoize the options array to prevent unnecessary re-renders
  const sectionOptions = React.useMemo(() => {
    return namedElements.map(({id, attrId}) => ({
      id,
      name: attrId || 'Unnamed Section',
    }));
  }, [namedElements]);

  return (
    <>
      {/* Section */}
      <Label
        data-automation-id="symbols-dataType-contentType"
        isOverride={isOverride}
      >
        Section
      </Label>

      <SectionSelectorPopover
        value={domId}
        onSectionChange={(value) => {
          onChange(value, {
            changeType: 'changeEnd',
          });
        }}
        options={sectionOptions}
      />
    </>
  );
};
